import React from 'react';
import {Link, withRouter} from 'react-router-dom';

import EpflLogo from './EpflLogo';
require('./menuStyle.css');

class EpflHeader extends React.Component {
  constructor(props){
    super(props);
    this.state = {currentPath: '/',
                  navAside: false};
    this.toogleSideNav.bind(this);
    this.closeSideNav.bind(this);
  }
  
  toogleSideNav(){
    this.setState({navAside: !this.state['navAside']})
    this.state['navAside'] ? 
    document.documentElement.style.setProperty("--nav-aside-pos", "-330px") :
    document.documentElement.style.setProperty("--nav-aside-pos", "0px");
  }
  closeSideNav(){
    this.setState({navAside: false});
    document.documentElement.style.setProperty("--nav-aside-pos", "-330px")
  }


  render () {
    // document height in pixels used for fullscreen overlay
    let h = document.documentElement.scrollHeight;

    const l1 = {
      display:"flex", position:"relative",
      height: "3px", width:"20px", margin:"4px",
      top:this.state["navAside"] ? "-3px" : "-9px",
      transform:this.state["navAside"] && "rotate(45deg)",
      transition:"all 0.5s, backgroundColor 0.5s, transform 0.5s",
      backgroundColor: this.state["navAside"] ? "#f00": "#000"
      };
    const l2 = {
      display:"flex", position:"relative",
      height: "3px", width:"20px", margin:"4px",
      top:this.state["navAside"] ? "-10px" : "-9px",
      transform:this.state["navAside"] && "rotate(-45deg)",
      transition:"all 0.5s, backgroundColor 0.5s, transform 0.5s",
      backgroundColor: this.state["navAside"] ? "#f00": "#000"
      };
    const l3 = {
      position:"relative", top:"-9px",
      display:this.state["navAside"] ? "none": "flex",
      height: "3px", width:"20px",
      margin:"0px 0px 0px 4px",
      backgroundColor:"#000"};

// contains the whole navigation history and allows to navigate programatically
let history = this.props.history;

  // build breadcrumb from the current path
  let path = history.location.pathname;

  let indexes = [], i = 0; // ignore the first '/'
  let pathName = [], paths = [], pathNames = [];
  while ((i = path.indexOf('/',i+1)) !== -1) {
    if (indexes.length === 0) {
      pathNames.push(path.substring(1,i))
    }
      else {
        pathNames.push(path.substring(indexes[indexes.length-1]+1,i))
      }
    indexes.push(i);
  }
  if (indexes.length > 0) {
    pathName = path.substring(indexes[indexes.length-1]+1,path.length);
    paths = indexes.map((i) => path.substring(0,i));
  }
  else {
    pathName = path.substring(1,path.length);
  }

  //console.log(paths)
  //console.log(pathNames)
  //console.log(this.props.website)

    return (
      <div className="site d-flex flex-column" style={{height: "120px"}}>

      <header className="header header-light">
      
      {/*
        <div className="drawer mr-3 mr-xd-0">
          <button className="drawer-toggle">
            <svg className="icon" aria-hidden="true">
              <use xlinkHref={'#icon-chevron-right'}/>
            </svg>
          </button>
          <a href="https://www.epfl.ch" className="drawer-link">
            <span className="text" >
              Go to main site
            </span>
          </a>
        </div>
      */}
        <a href="https://www.epfl.ch/" style={{padding: "10px"}}>
          <EpflLogo/>
        </a>
        <div className="header-light-content" 
            style={{"display":"flex"}}>
                          <button className ="btn btn-primary" onClick={() => {history.push('/');
                                this.closeSideNav()}} style={{marginRight: "10px"}} >
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-home"></use>
                      </svg>
            </button>
          <span className="custom-nav-bar">

            {this.props.website.map((page,i) => {
              if (page["visible_in_menu"] === true)
              return (
                <span  className="menu-dropdown" key={i}>
                  <button  className="btn" onClick={() => {history.push(page['path'])}}>
                    {page['title']}
                    {page['children'].length > 0 && 
                            <svg className="icon" aria-hidden="true">
                              <use xlinkHref="#icon-chevron-right"></use>
                            </svg>}
                  </button>
                  {page['children'].length > 0 ?
                          <span className="menu-dropdown-content">
                              {
                                page['children'].map((subpage,j) => {
                                  if (subpage["visible_in_menu"] === true)
                                  return (
                                      <a className="btn btn-menu" onClick={ () => history.push(page['path'] + subpage['path'])}  key={10*i + j+100}>
                                        {subpage['title'] }
                                      </a> 
                                  )
                                })
                              }
                            
                          </span> 
                        
                      : ''
                    }
                </span>
                )
              })
            }
          </span>

          <div className="custom-nav-menu">
            <div className="btn btn-secondary nav-toggle-mobile"  style={{zIndex:"5"}} onClick={() => {
              this.toogleSideNav()
              }}>
              <span className="lab">Menu</span>
              <div style={{width:"20px",height:"20px",marginLeft:"5px"}}>
                <span style={l1}></span>
                <span style={l2}></span>
                <span style={l3}></span>
              </div>
            </div>
          </div>
          {this.state["navAside"] &&
            <div className="fullScreenOverlay" onClick={()=> this.closeSideNav()}
              style={{height:h}}>
            </div>
          }
          <div className="search-EN group" 
          style={{"display":"flex","width":"70px",
          "marginLeft":"auto"}}>

            <div className="custom-nav-search" >
              <form action="https://search.epfl.ch" className="d-xd-none">
                <a id="search-mobile-toggle" className="search-mobile-toggle searchform-controller" href="#">
                  <svg className="icon" aria-hidden="true" style={{alignContent:"down"}}>
                    <use xlinkHref="#icon-search"></use>
                  </svg>
                  <span className="toggle-label sr-only">Show / Hide search form</span>
                </a>
                <div className="input-group search-mobile" role="search">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-search"></use>
                      </svg>
                    </span>
                  </div>
                  <label htmlFor="q-mobile" className="sr-only">Search</label>
                  <input type="text" className="form-control" id="q-mobile" name="q" placeholder="Search"/> 
                  <div className="input-group-append">
                    <button id="search-mobile-close" className="search-mobile-close searchform-controller" href="#">
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-close"></use>
                      </svg>
                      <span className="toggle-label sr-only">Hide search form</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div className="dropdown dropright search d-none d-xd-block">
              <button className="dropdown-toggle" href="#" data-toggle="dropdown">
                <svg className="icon" aria-hidden="true">
                  <use xlinkHref="#icon-search"></use>
                </svg>
              </button>
              <form action="https://search.epfl.ch" className="dropdown-menu border-0 p-0" >
                <div className="search-form mt-1 input-group" >
                  <label htmlFor="q" className="sr-only">Search</label>
                  <input type="text" className="form-control" id="q" name="q" placeholder="Search"/>
                  <button type="submit" className="d-none d-xd-block btn btn-primary input-group-append">Search</button>
                </div>
              </form>
            </div>
    
            <nav className="nav-lang nav-lang-short ml-auto">
              <ul>
                <li>
                  <span className="active" aria-label="English">EN</span>
                </li>
              </ul>
            </nav>


          </div>

          
          {<nav id="nav-aside" className={"nav-aside" }>
            {/*<a href="" onClick={() => {history.push('/');this.toogleSideNav()}}><h2 className="h5 sr-only-xl">Home</h2> </a>
             */}
            <ul>
            {this.props.website.map((page,i) => {
            if (page["visible_in_menu"] === true)
              return (
                <li key={i}>
                  <a onClick={() => {history.push(page['path']);this.toogleSideNav()}}>
                    {page['title']}
                    {page['children'].length > 0 && 
                            <svg className="icon" aria-hidden="true">
                              <use xlinkHref="#icon-chevron-right"></use>
                            </svg>}
                  </a>
                  {page['children'].length > 0 ?
                          <ul >
                              {
                                page['children'].map((subpage,j) => {
                                  if (subpage["visible_in_menu"] === true)
                                  return (
                                    <li key={j}>
                                      <a onClick={ () => {history.push(page['path'] + subpage['path']);this.toogleSideNav()}}  key={10*i + j+100}>
                                        {subpage['title'] }
                                      </a>
                                    </li> 
                                  )
                                })
                              }
                            
                          </ul> 
                        
                      : ''
                    }
                </li>
                )
              })
            }
            </ul>
          </nav>
          }
          <nav aria-label="breadcrumb" className="breadcrumb-wrapper">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <svg className="icon" aria-hidden="true">
                      <use xlinkHref="#icon-home"></use>
                    </svg>
                    </Link>
                </li>
                {paths.map( (p,i) => <li className="breadcrumb-item" key={i}><Link to={p}>{pathNames[i]}</Link></li>)}

                <li className="breadcrumb-item active" aria-current="page">{pathName}</li>
            </ol>
          </nav>
        </div>

      </header>
    </div>
    );
        }
}

export default withRouter(EpflHeader);
